import React, {useState, useRef} from "react";
import {Carousel, Row, Col} from "antd";
import {LeftCircleOutlined, RightCircleOutlined} from "@ant-design/icons";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const SampleNextArrow = (props) => {
    const {className, style, onClick} = props;
    return (
        <div
            className={className}
            style={{
                ...style,
            }}
            onClick={onClick}
        >
            <p className="arrows">
                <RightCircleOutlined />
            </p>
        </div>
    );
};
const SamplePrevArrow = (props) => {
    const {className, style, onClick} = props;
    return (
        <div className={className} style={{...style}} onClick={onClick}>
            <p className="arrows">
                <LeftCircleOutlined />
            </p>
        </div>
    );
};

const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
};

const CarouselArrows = (props) => {
    return (
        <>
            <Carousel
                autoplay
                arrows
                {...settings}
                style={{
                    width: "80%",
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    backgroundSize: "cover",
                }}
            >
                {props.imageArray.map((image) => {
                    return (
                        <div className="ModelImage">
                            <img src={`/Images/Showroom/${image}`} />
                        </div>
                    );
                })}
            </Carousel>
        </>
    );
};

function ModelCutDetails(props) {
    let [openImage, setOpenImage] = useState({state: false, image: ""});

    const imageArray = [
        props.details.image,
        props.details.image,
        props.details.image,
    ];

    return (
        <div className="ModelDetailsPage">
            <div className="ModelImages">
                <CarouselArrows imageArray={imageArray} />
            </div>

            <div className="ProductImages">
                {imageArray.map((image) => {
                    return (
                        <div className="ProductImage">
                            <img
                                className="img"
                                src={`/Images/Showroom/${image}`}
                                style={{cursor: "pointer"}}
                                onClick={() => {
                                    setOpenImage({
                                        ...openImage,
                                        state: true,
                                        image: image,
                                    });
                                }}
                            />
                        </div>
                    );
                })}
                {/* ENLARGE PRODUCT CUT IMAGE ON CLICK */}
                {openImage.state && (
                    <Lightbox
                        mainSrc={`/Images/Showroom/${openImage.image}`}
                        onCloseRequest={() =>
                            setOpenImage({
                                ...openImage,
                                state: false,
                                image: "",
                            })
                        }
                    />
                )}
            </div>
        </div>
    );
}

export default ModelCutDetails;
